import React from "react";
import Nav from "./Nav";
const Header = () => {
  return (
    <header>
      <h1>Country App</h1>
      <Nav />
    </header>
  );
};

export default Header;
